import React from "react";
import PropTypes from "prop-types";
import { useAPI } from "components/hooks/useAPI";

export const SignOutButton = ({label = 'Log out'}) => {
  const api = useAPI();

  return <button onClick={api.signOut}>{label}</button>;
};
SignOutButton.propTypes = {
  label: PropTypes.string,
};
